import AjaxUtils from "../../util/ajax_utils";
import { generateColourRange, CRITICAL, HIGH, MEDIUM, LOW, INFO } from "../../util/colour";
import { getFlagEmoji } from "../../util/iso3166_tools";
import VueApexCharts from "vue-apexcharts";


//Mapping use
//https://jvectormap.com/tutorials/getting-started/
// Consider https://www.amcharts.com/javascript-charts/
export const MapPanel = {
    props:{
        title: {
            type: String,
            default: "Location Map",
            required: false
        },
        icon: {
            type: String,
            default: "",
            required: false
        },
        src: {
            type: String,
            default: '',
            required: false
        },
        data: {
            type: Object,
            default: function() {
                return null;
            },
            required: false
        },
        name: {
            type: String,
            default: 'Assets',
            required: false
        },
        colorStart: {
            type: String,
            default: '#2562ec',
            required: false
        },
        colorEnd: {
            type: String,
            default: '#e1e8ef',
            required: false
        },
        colors: {
            type: Array,
            default: function() {
                return [];
            },
            required: false
        },
        colorSteps: {
            type: Number,
            default: 20,
            required: false
        },
        buildQuery: {
            type: Boolean,
            default: false,
            required: false
        },
        query: {
            type: String,
            default: "",
            required: false
        },
        search: {
            type: String,
            default: '/asset-manager/search',
            required: false
        }
    },
    data: function() {
        let cmp = this;
        let colours = cmp.colors.length ? cmp.colors : generateColourRange(cmp.colorStart, cmp.colorEnd, cmp.colorSteps).reverse();

        let values = {
            view_data: cmp.data ? cmp.data : {},
            scale: colours,
            map: null,
            loading: false
        };
        return values;
    },
    methods: {
        draw: function() {
            let cmp = this;

            let steps = (cmp.view_data.length < cmp.colorSteps) ? (cmp.view_data.length + 1) : cmp.colorSteps;
            cmp.scale.colours = cmp.colors.length ? cmp.colors : generateColourRange(cmp.colorStart, cmp.colorEnd, steps).reverse();

            $(cmp.$refs.mapPanel).empty();
            cmp.map = $(cmp.$refs.mapPanel).vectorMap({
                map: 'world_mill',
                backgroundColor: 'transparent',
                regionStyle: {
                    initial: {
                        fill: '#94a3b8',
                        //stroke: "#676767",
                        //strokeWidth: 2.5,
                        fillOpacity: 1
                    }
                },
                series: {
                    regions: [{
                        values: cmp.view_data,
                        scale: cmp.scale,
                        normalizeFunction: 'polynomial'
                    }]
                },
                onRegionTipShow: function(e, el, code){
                    let val = el.html();
                    let count = cmp.view_data[code];
                    let name = cmp.name;
                    if(count !== undefined) {
                        let display = `${val} (${name} - ${count})`;
                        el.html(display);
                    } else {
                        let display = `${val} (No ${name})`;
                        el.html(display);
                    }
                },
                onRegionClick: function(event, code){
                    if (cmp.buildQuery) {
                        let param = code;
                        window.location = `${cmp.search}?${cmp.query}=${param}`;
                    }
                }
            });
            cmp.loading = false;
        },
        refresh: function() {
            let cmp = this;

            if(cmp.src) {
                let url = cmp.src;
                cmp.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.view_data = data.data;
                                cmp.loading = false;
                            }
                        } else {

                        }
                        cmp.draw();
                    },
                    fail: function (data) {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false
                    }
                });
            } else {
                cmp.draw();
            }
        }
    },
    mounted: function(){
        let cmp = this;
        cmp.refresh()
    },
    template: `
        <apck-panel :title="title" :icon="icon" no-padding>
            <template v-slot:menu>
                <apck-button
                    :handler="refresh"
                    icon="fa-refresh"
                    title="Refresh"
                    class="title-button"
                />
            </template>
            <div ref="mapPanel" class="map-view"></div>
            <apck-mask :trigger="loading" />
        </apck-panel>
    `
};

export const AssetSearchResult = {
    props: {
        vulns: {
            type: Object,
            default: function(){
                let vulns = {
                    critical: 0,
                    high: 0,
                    medium: 0,
                    low: 0,
                    info: 0
                };
                return vulns;
            },
            required: true
        },
        result: {
            type: Object,
            required: true
        }
    },
    data: function() {
        let cmp = this;
        let default_vulns = {
            critical: 0,
            high: 0,
            medium: 0,
            low: 0,
            info: 0
        };

        let vulns = Object.assign(default_vulns, cmp.vulns);

        let result = cmp.result;

        let values = {
            vuln_data: vulns,
            data: result
        };
        return values;
    },
    computed: {
        list_names: function() {
            let cmp = this;
            let names = [cmp.data.NiceName];
            //Add hostnames
            for(let i=0; i<cmp.data.Hostnames.length; i++) {
                let _hostname = cmp.data.Hostnames[i];
                if(names.indexOf(_hostname) === -1) {
                    names.push(_hostname);
                }
            }
            //Add IPs
            for(let i=0; i<cmp.data.IPs.length; i++) {
                let _ip = cmp.data.IPs[i];
                if(names.indexOf(_ip) === -1) {
                    names.push(_ip);
                }
            }
            //Remove the first item, as it will be a duplicate
            names.shift();
            //Return our list of names
            return names;
        },
        iso_3166_flag: function() {
            let cmp = this;
            let code = cmp.data.iso_3166.toLowerCase();
            let icon = `/assets/images/flags/${code}.png`;
            return icon;
        },
        asset_url: function() {
            let cmp = this;
            let id = cmp.data.ID;
            let url = `/asset-manager/summary/${id}`;
            return url;
        }
    },
    template: `
        <div class="asset-search-result">
            <div class="row">
                <div class="col col-xs-4">

                    <h2 class="result-header">
                        <a :href="asset_url">
                            {{ data.NiceName }}
                        </a>
                    </h2>

                    <div class="result-names">
                        <span v-for="name in list_names">
                            {{ name }}
                        </span>
                    </div>

                    <div v-if="data.CPEs.length" class="result-software">
                        <hr />
                        <span v-for="name in data.CPEs">
                            {{ name }}
                        </span>
                    </div>

                    <div class="result-location">
                        <img :src="iso_3166_flag" />
                        {{ data.Country}}
                    </div>

                    <div class="search-results-vuln">
                        <span class="vuln-count severity-critical-text">
                            {{ vuln_data.critical }}
                        </span>
                        /
                        <span class="vuln-count severity-high-text">
                            {{ vuln_data.high }}
                        </span>
                        /
                        <span class="vuln-count severity-medium-text">
                            {{ vuln_data.medium }}
                        </span>
                        /
                        <span class="vuln-count severity-low-text">
                            {{ vuln_data.low }}
                        </span>
                        /
                        <span class="vuln-count severity-info-text">
                            {{ vuln_data.info }}
                        </span>
                    </div>
                </div>

                <div v-if="data.Certificates.length" class="col col-xs-4">
                    <h2 class="result-header">
                        Certificate
                    </h2>

                    <pre class="code">
The SMB account used for this test does not have sufficient privileges to get
the list of the hotfixes installed on the remote host. As a result, Nessus was
not able to determine the missing hotfixes on the remote host and most SMB checks
have been disabled.

Solution : Configure the account you are using to get the ability to connect to ADMIN$
                    </pre>
                </div>

                <div v-if="data.Banners.length" class="col col-xs-4">
                    <h2 class="result-header">
                        Banners
                    </h2>
                    <div v-for="banner in data.Banners">
                        <h3>{{ banner.address }}:{{ banner.port }}</h3>
                        <pre  class="code">
{{ banner.banner }}
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    `
};

export const AssetSearchPanel = {
    components: {
        'vuln-result': AssetSearchResult,
    },
    props: {
        src: {
            type: String,
            default: '',
            required: false
        },
        search: {
            type: String,
            default: '',
            required: false
        }
    },
    data: function() {
        let cmp = this;
        let values = {
            query: cmp.search,
            last_query: "",
            view_data: [],
            count: 0,
            loading: false
        };
        return values;
    },
    methods: {
        updateLocationSearchWithoutRefresh: function (newParams) {
            const newSearch = new URLSearchParams(newParams).toString();
            const newUrl = window.location.pathname + '?' + newSearch + window.location.hash;

            // Update the URL without refreshing the page
            history.pushState({ path: newUrl }, '', newUrl);
        },
        triggerSearch: function() {
            let cmp = this;
            let url = cmp.src;
            let query = {};
            if (cmp.query) {
                query['query'] = cmp.query
            }

            cmp.updateLocationSearchWithoutRefresh(query);

            if(cmp.src) {
                cmp.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    query_params: query,
                    success: function (data) {
                        console.log(data);
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.view_data = data.data.results;
                                cmp.count = data.data.total_count;
                                cmp.last_query = cmp.query;
                            }
                        } else {

                        }
                        cmp.loading = false;
                    },
                    fail: function (data) {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false
                    }
                });
            }
        }
    },
    mounted: function() {
        let cmp = this;
        cmp.triggerSearch()
    },
    template: `
        <div class="asset-search-wrapper">
            <apck-titlebar title="Asset Search">
                <template v-slot:actions>
                    <apck-button
                        icon="fa-bars"
                        title="Switch to list view"
                        class="btn-primary"
                    />
                </template>
            </apck-titlebar>

            <div class="search-bar">
                <div class="form-field">
                    <input
                        type="text"
                        v-on:change="triggerSearch"
                        v-model="query"
                        placeholder="Search..."
                    >
                </div>
            </div>

            <div class="asset-search-results">
                <div v-if="view_data.length">
                    <span class="results_counter">
                        Found {{ count }} results<span v-if="last_query"> for query "{{ last_query }}"</span>
                    </span>
                    <vuln-result v-for="item in view_data" :key="item.ID" :vulns="item.Vulns" :result="item" />
                </div>
                <div v-if="!view_data.length">
                    <h1>No Results</h1>
                </div>
            </div>
            <apck-mask :trigger="loading" />
        </div>
    `
};

export const ApckTreemapChart = {
    components: {
        'apexchart': VueApexCharts,
    },
    props: {
        title: {
            type: String,
            default: "",
            required: false
        },
        icon: {
            type: String,
            default: "",
            required: false
        },/*
        chartType: {
            type: String,
            default: 'treemap',
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {};
            }
        },
        defaultChartSeries: {
            type: Array,
            default: function () {
                return [];
            }
        },
        */
        src: {
            type: String,
            default: '/asset-manager/software/counter',
            required: false
        },
        query: {
            type: String,
            default: "",
            required: false
        },
        search: {
            type: String,
            default: '/asset-manager/search',
            required: false
        },
        colors: {
            type: Array,
            default: function(){
                return ['#1890ff', '#27ae60'];
            },
            required: false
        }
    },
    data: function() {
        let cmp = this;
        let series = [];
        let colors = cmp.colors;
        let options = {
            legend: {
                show: false
            },
            colors: colors,
            chart: {
                toolbar: {
                    show: false,
                    tools: {
                        download: false // This disables the download option
                    }
                },
                events: {
                    click: function(event, chartContext, config) {
                        // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                        let dataPointIndex = config.dataPointIndex;
                        let seriesIndex = config.seriesIndex;
                        // Access the clicked cell's data
                        let clickedData = cmp.chartSeries[seriesIndex].data[dataPointIndex];
                        window.location = cmp.searchQuery({name: clickedData['x']});
                    }
                }
            },
            xaxis: {
                show: false,
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                show: false,
                axisTicks: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                labels: {
                    show: false,
                },
            }
        };
        return {
            chartOptions: options, //this.defaultChartOptions,
            chartSeries: series, //this.defaultChartSeries,
            loading: false
        };
    },
    methods: {
        refresh: function() {
            let cmp = this;
            let url = cmp.src;
            if(cmp.src) {
                cmp.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.chartSeries = data.data;
                            }
                        } else {

                        }
                        cmp.loading = false;
                    },
                    fail: function (data) {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false
                    }
                });
            }
        },
        searchQuery: function(item) {
            let param = item['name'];
            if(item['iso_3166']) {
                param = item['iso_3166'];
            }
            return `${this.search}?query=${this.query}:${param}`;
        },
    },
    computed: {
        chartType: function() {
            return 'treemap';
        },
        defaultChartOptions: function() {
            return {};
        },
        defaultChartSeries: function() {
            return [];
        }
    },
    mounted: function() {
        let cmp = this;
        this.refresh()
    },
    template: `
        <apck-panel class="asset-counter-panel" :title="title" :icon="icon" no-padding >
            <template v-slot:menu>
                <apck-button
                    :handler="refresh"
                    icon="fa-refresh"
                    title="Refresh"
                    class="title-button"
                />
            </template>
            <div class="tree-chart">
                <apexchart :type="chartType" :options="chartOptions" :series="chartSeries" :height="280" />
            </div>
            <apck-mask :trigger="loading" />
        </apck-panel>
    `
}

export const DashboardQueryPanel = {
    components: {
        'apexchart': VueApexCharts,
    },
    props: {
        useNewListStyle: {
            type: Boolean,
            default: false
        },
        newListStyleCols: {
            type: String,
            default: '1',
        },
        newListStyleGap: {
            type: String,
            default: '1',
        },
        newListStylePanelType: {
            type: String,
            default: 'base',
            validator: function (value) {
                return ['base', 'counter'].includes(value);
            }
        },
        title: {
            type: String,
            default: "",
            required: false
        },
        icon: {
            type: String,
            default: "",
            required: false
        },
        data: {
            type: Array,
            default: function(){
                return [];
            },
            required: false
        },
        src: {
            type: String,
            default: "",
            required: false
        },
        query: {
            type: String,
            default: "",
            required: false
        },
        search: {
            type: String,
            default: '/asset-manager/search',
            required: false
        },
        view: {
            type: String,
            default: 'list',
            required: false
        },
        views: {
            type: Array,
            default: function(){
                return ['list', 'bar', 'treemap', 'donut', 'radialBar'];
            },
            required: false
        },
        colorStart: {
            type: String,
            default: '#1890ff',
            required: false
        },
        colorEnd: {
            type: String,
            default: '#ffffff',
            required: false
        },
        colors: {
            type: Array,
            default: function(){
                //return ['#1890ff', '#27ae60'];
                return [
                    "#f4ce3b", // Yellow
                    "#54c3ae", // Light teal
                    "#3bc3df", // Light blue
                    "#ffad4b", // Orange
                    "#1f93fe", // Bright blue
                    "#E84393", // Hot pink
                    "#A3CB38", // Vibrant green
                    "#55DDE0", // Teal
                    "#9B59B6", // Purple
                    "#EB8425", // Lighter orange
                    "#20C997", // Turquoise green
                    "#FFC312", // Light yellow
                    "#0652DD", // Deep blue
                    "#F79F1F", // Dark orange
                    "#8E44AD", // Deep purple
                    "#FAD128", // Bright yellow
                    "#1E90FF", // Medium bright blue
                    "#C23583", // Magenta
                    "#78C350", // Light green
                    "#FDAC07", // Orange
                    "#3498DB", // Blue
                    "#EE5A24", // Reddish orange
                    "#F46FC8", // Pink
                    "#2ECC71", // Green
                    "#EA2027", // Red
                ];
            },
            required: false
        },
        colorSteps: {
            type: Number,
            default: 20,
            required: false
        },
        legend: {
            type: Boolean,
            default: false
        },
        buildQuery: {
            type: Boolean,
            default: true
        },
        chartHeight: {
            type: Number,
            default: null
        },
        useImageFlag: {
            type: Boolean,
            default: true
        },
        tooltipPosition: {
            type: String,
            default: 'top',
            validator: function (value) {
                return ['top', 'bottom', 'left', 'right'].includes(value);
            }
        },
    },
    data: function() {
        let cmp = this;
        let supportedViews = [];
        for(let index in cmp.views) {
            let view = cmp.views[index];
            supportedViews.push({
                'name': view,
                'icon': cmp.modeIcon(view)
            });
        }
        let values = {
            view_data: cmp.data ? cmp.data : [],
            count: 0,
            loading: true,
            currentView: cmp.view,
            supportedViews: supportedViews,
            chartSeries: []
        };
        return values;
    },
    methods: {
        iso_3166_flag_utf8: function(country_code) {
            let code = country_code.toLowerCase();
            let icon = getFlagEmoji(code);
            return icon;
        },
        iso_3166_flag_image: function(country_code) {
            // https://github.com/joielechong/iso-country-flags-svg-collection
            let code = country_code.toLowerCase();
            let icon = `/assets/images/svg_flags/${code}.svg`;
            return icon;
        },
        buildSearchUrl: function(baseSearch, queryParam, value) {
            // Split the base search into path and existing query string
            let [path, existingQuery] = baseSearch.split('?');
            
            // Create URLSearchParams object
            let params = new URLSearchParams(existingQuery || '');
            
            // Add the new query parameter
            params.set(queryParam, value);
            
            // Build the final URL
            return `${path}?${params.toString()}`;
        },
        searchQuery: function(item) {
            let param = item['name'];

            if(item['iso_3166']) {
                param = item['iso_3166'];
            } else if (item.name.toLowerCase() in this.riskLevelOptions) {
                const name = item.name.toLowerCase();
                param = this.riskLevelOptions[name]
            }

            return this.buildSearchUrl(this.search, this.query, param);
        },
        refresh: function() {
            let cmp = this;
            let url = cmp.src;

            if(cmp.src) {
                cmp.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        console.log(data);
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.view_data = data.data;
                                cmp.count = data.total;
                                cmp.chartSeries = cmp.buildChartSeries();
                            }
                        } else {

                        }
                        cmp.loading = false;
                    },
                    fail: function (data) {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false
                    }
                });
            }
        },
        switchType: function(type) {
            let cmp = this;
            return function() {
                if(cmp.views.indexOf(type) !== -1) {
                    cmp.currentView = type;
                   cmp.refresh();
                }
            }
        },
        modeIcon: function(type) {
            switch(type) {
                case "list":
                    return "fa-list";
                case "treemap":
                    return "fa-th";
                case "bar":
                    return "fa-bar-chart";
                case "donut":
                    return "fa-chart-pie";
                case "radialBar":
                    return "fa-chart-pie";
                default:
                    return "fa-circle-question";
            }
        },
        buildChartSeriesDonut: function(series) {
            let cmp = this;
            let _results = [];
            let other = 0;
            for(let i=0; i<cmp.view_data.length; i++){
                let item = cmp.view_data[i];
                if(item.count === 1) {
                    other += 1;
                } else {
                    _results.push(series ? item.count : item.name);
                }
            }
            if(other) {
                _results.push(series ? other : 'Other');
            }
            return _results;
        },
        buildChartSeries: function() {
            if (this.chartType === 'donut' || this.chartType === 'radialBar') {
                // For donut, we just return an array of counts, one value per slice
                // Ideally want to process this down so that anything that is a single item of other.
                return this.buildChartSeriesDonut(true);
            } else {
                // For bar/treemap, return the usual series structure
                return [
                    {
                        name: 'Series 1',
                        data: this.view_data.map(item => {
                            return {
                                x: item.name,
                                y: item.count
                            };
                        })
                    }
                ];
            }
        },
        setIconAndColor(name) {
            const opts = {
                highest: {
                    color: 'destructive',
                    panelColor: 'red',
                    icon: 'fa-triangle-exclamation'
                },
                critical: {
                    color: 'destructive',
                    panelColor: 'red',
                    icon: 'fa-triangle-exclamation'
                },
                high: {
                    color: 'orange',
                    panelColor: 'orange',
                    icon: 'fa-chevrons-up'
                },
                medium: {
                    color: 'warning',
                    panelColor: 'yellow',
                    icon: 'fa-bug'
                },
                low: {
                    color: 'success',
                    panelColor: 'green',
                    icon: 'fa-chevrons-down'
                },
                informational: {
                    color: 'info',
                    panelColor: 'blue',
                    icon: 'fa-circle-info'
                },
                investigate: {
                    color: 'secondary',
                    panelColor: 'light-slate',
                    icon: 'fa-binoculars'
                },
            }

            const strippedName = name.toLowerCase().replace(' risk', '')

            const fallback = {
                color: 'primary',
                panelColor: undefined,
                icon: undefined,
            }

            return opts[strippedName] || fallback
        },
    },
    computed: {
        riskLevelOptions() {
            return {
                "highest": 5,
                "critical": 5,
                "high": 4,
                'medium': 3,
                'low': 2,
                'informational': 1,
                'investigate': 0
            }
        },
        load_button_text: function() {
            let cmp = this;
            return `View all ${cmp.count} records`;
        },
        chartType: function() {
            let cmp = this;
            return cmp.currentView;
        },
        chartOptions: function() {
            let cmp = this;
            // If we have fewer items than the number of steps, we only want to colour for the items we have
            // We add plus one to the steps to account for the not wanting solid white.
            let steps = (cmp.view_data.length < cmp.colorSteps) ? (cmp.view_data.length + 1) : cmp.colorSteps;

            let options = {
                legend: {
                    show: cmp.legend,
                    floating: true,
                    offsetY: 0
                },
                colors: cmp.colors.length ? cmp.colors : generateColourRange(cmp.colorStart, cmp.colorEnd, steps),
                stroke: {
                    show: false
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                chart: {
                    height: cmp.chartHeight ? cmp.chartHeight : 'auto',
                    width: '100%',
                    offsetX: 0,
                    offsetY: 0,
                    parentHeightOffset: 0,
                    toolbar: {
                        show: false,
                        tools: {
                            download: false // This disables the download option
                        }
                    },
                    events: {
                        click: function(event, chartContext, config) {
                            // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                            let i = config.dataPointIndex;
                            // For donut:
                            if (cmp.chartType === 'donut' || cmp.chartType === 'radialBar') {
                                if (i >= 0 && i < cmp.view_data.length) {
                                    let item = cmp.view_data[i];
                                    // item has {name, count, ...}
                                    if(cmp.buildQuery) {
                                        window.location = cmp.searchQuery(item);
                                    }
                                }
                            } else {
                                // For bar/treemap:
                                if(cmp.buildQuery) {
                                    let seriesIndex = config.seriesIndex;
                                    let clickedData = cmp.chartSeries[seriesIndex].data[i];
                                    window.location = cmp.searchQuery({ name: clickedData.x });
                                }
                            }
                        },
                        mounted: (ctx) => {
                            if(cmp.chartType === 'treemap') {
                                console.log(ctx);
                                console.log('Treemap mounted');
                                const g = ctx.el.querySelector('.apexcharts-inner');
                                if (g) {
                                    g.setAttribute('transform', 'translate(0, 10)');
                                }
                            }
                        }
                    }
                },
                grid: {
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                xaxis: {
                    show: cmp.chartType === 'bar',
                    labels: {
                        show: cmp.chartType === 'bar',
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                },
                yaxis: {
                    show: cmp.chartType === 'bar',
                    labels: {
                        show: cmp.chartType === 'bar',
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                }
            };
            // If donut, supply slice labels
            if (cmp.chartType === 'donut' || cmp.chartType === 'radialBar') {
                options.labels = cmp.buildChartSeriesDonut(false);
            }
            return options;
        }
    },
    mounted: function() {
        let cmp = this;
        cmp.refresh();
    },
    template: `
        <apck-panel class="asset-counter-panel" :title="title" :icon="icon" :class="useNewListStyle ? 'new-ui' : ''">
            <template v-slot:menu>
                <!--
                The buttons to control the present data view.
                -->
                <apck-button
                    v-if="supportedViews.length > 1"
                    v-for="type in supportedViews"
                    :key="type.name"
                    :handler="switchType(type.name)"
                    :icon="type.icon"
                    title="Change the mode"
                    :class="['title-button', (currentView === type.name) ? 'active' : '']"
                />

                <apck-button
                    :handler="refresh"
                    icon="fa-refresh"
                    title="Refresh"
                    class="title-button"
                />
            </template>
            <template v-if="currentView === 'list'">
                <ui-layout v-if="useNewListStyle" type="grid" :cols="newListStyleCols" :gap="newListStyleGap" class="asset-dashboard-query-panel">
                    <template v-if="newListStylePanelType === 'counter'">
                        <ui-panel-counter
                            v-for="item in view_data"
                            :key="item.id"
                            :tag="buildQuery ? 'a' : 'div'"
                            :url="buildQuery ? searchQuery(item) : ''"
                            :title="item.name"
                            :value="Number(item.count) || 0"
                            :color="setIconAndColor(item.name).panelColor"
                            :icon="setIconAndColor(item.name).icon"
                            :iconType="setIconAndColor(item.name).color"
                            :loading="loading"
                            v-tooltip:[tooltipPosition]="item.tooltip"
                        />
                    </template>
                    <template v-else>
                        <ui-panel-base
                            v-for="item in view_data"
                            align="center"
                            :key="item.id"
                            :tag="buildQuery ? 'a' : 'div'"
                            :url="buildQuery ? searchQuery(item) : ''"
                            v-tooltip:[tooltipPosition]="item.tooltip"
                        >
                            <ui-layout gap="2" align="center">
                                <ui-flag v-if="item.iso_3166" :code="item.iso_3166" size="sm" />
                                
                                <ui-icon
                                    v-else
                                    :icon="setIconAndColor(item.name).icon"
                                    :type="setIconAndColor(item.name).color"
                                    size="sm"
                                />

                                <ui-heading
                                    tag="span"
                                    size="sm"
                                    :class="'text--' + setIconAndColor(item.name).color"
                                >
                                    {{ item.name }}
                                </ui-heading>
                            </ui-layout>
                            <ui-heading tag="span" size="sm" :class="'text--' + setIconAndColor(item.name).color">
                                {{ item.count }}
                            </ui-heading>
                        </ui-panel-base>
                    </template>
                </ui-layout>
                
                <div v-else class="list" height="chartHeight">
                    <table class="asset-dashboard-query-panel">
                        <colgroup>
                           <col span="1" style="width: 80%;">
                           <col span="1" style="width: 20%;">
                        </colgroup>
                        <tbody>
                            <tr v-for="item in view_data" v-tooltip:[tooltipPosition]="item.tooltip">
                                <td>
                                    <component
                                        :is="buildQuery ? 'a' : 'span'"
                                        class="asset-list-text"
                                        v-bind="buildQuery ? { href: searchQuery(item) } : {}"
                                    >
                                        <img v-if="item.iso_3166 && useImageFlag" :src="iso_3166_flag_image(item.iso_3166)" class="asset-flag-icon" />
                                        <span v-if="item.iso_3166 && !useImageFlag" class="asset-flag-icon">
                                            {{ iso_3166_flag_utf8(item.iso_3166) }}
                                        </span>
                                        {{ item.name }}
                                    </component>
                                </td>
                                <td>
                                    <span class="item-count">
                                        {{ item.count }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>

            <div v-if="currentView !== 'list'" :class="[currentView + '-chart']" :style="chartHeight ? 'height: ' + chartHeight  + 'px' : null">
                <apexchart
                    :type="chartType"
                    :options="chartOptions"
                    :series="chartSeries"
                />
            </div>

            <apck-mask :trigger="loading" />
        </apck-panel>
    `
};

/*
<!--
                <div v-if="count && count > view_data.length" class="asset-query-buttons">
                    <apck-button
                        icon="fa-eye"
                        :right="true"
                        :title="load_button_text"
                        class="btn-positive"
                        :value="load_button_text"
                    />
                </div>
                -->
*/

export const ApckVulnCounter = {
    props: {
        title: {
            type: String,
            default: "Vulnerabilities",
            required: false
        },
        icon: {
            type: String,
            default: "fa-bug",
            required: false
        },
        src: {
            type: String,
            default: "/asset-manager/vulns/counter",
            required: false
        }
    },
    data: function() {
        let values = {
            view_data: {
                'critical': {
                    'count': 0,
                    'assets': 0,
                    'infra': 0,
                    'web_app': 0
                },
                'high': {
                    'count': 0,
                    'assets': 0,
                    'infra': 0,
                    'web_app': 0
                },
                'medium': {
                    'count': 0,
                    'assets': 0,
                    'infra': 0,
                    'web_app': 0
                },
                'low': {
                    'count': 0,
                    'assets': 0,
                    'infra': 0,
                    'web_app': 0
                },
                'info': {
                    'count': 0,
                    'assets': 0,
                    'infra': 0,
                    'web_app': 0
                }
            },
            loading: false
        }
        return values
    },
    methods: {
        refresh: function() {
            let cmp = this;
            let url = cmp.src;
            if(cmp.src) {
                cmp.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        if (data) {
                            if (data.success && data.success === true) {
                                cmp.view_data = Object.assign(cmp.view_data, data.data);
                            }
                        } else {

                        }
                        cmp.loading = false;
                    },
                    fail: function (data) {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        show_success_flash: false,
                        flash_404_errors: false
                    }
                });
            }
        },
        asset_summary: function(key) {
            let cmp = this;
            let summary = `
Assets: ${cmp.view_data[key].assets},
(${cmp.view_data[key].infra} are infrastructure, ${cmp.view_data[key].web_app} are applications)
`;
            return summary;
        }
    },
    mounted: function() {
        let cmp = this;
        this.refresh();
    },
    template: `
        <apck-panel class="vuln-counters-panel" :icon="icon" no-padding no-border>
            <!--
            <template v-slot:menu>
                <apck-button
                    :handler="refresh"
                    icon="fa-refresh"
                    title="Refresh"
                    class="title-button"
                />
            </template>
            -->

            <div class="unfixed-count-panel">

                <div v-for="key in Object.keys(view_data)" class="flex-column">
                    <div :class="[key + '-panel']">
                        <span class="panel-count-text">
                            {{ view_data[key].count }}
                        </span>

                        <VueCustomTooltip :label="asset_summary(key)">
                            <span class="panel-count-asset">
                                <i class="fa fa-list-alt" /> {{ view_data[key].assets }}
                                <i class="fa fa-server" /> {{ view_data[key].infra }}
                                <i class="fa fa-globe" /> {{ view_data[key].web_app }}
                            </span>
                        </VueCustomTooltip>
                    </div>

                    <div class="panel-title">
                        <span class="panel-title-text">
                            {{key}}
                        </span>
                    </div>
                </div>
                
            </div>
            <apck-mask :trigger="loading" />
        </apck-panel>
    `
}


export const ApckAssetDashboard = {
    components: {
        'apck-query-panel': DashboardQueryPanel,
        'apck-vuln-counter': ApckVulnCounter,
        'apck-map-panel': MapPanel
    },
    props: {

    },
    data: function() {
        let values = {
            countries: [{
                name: 'United Kingdom',
                iso_3166: 'GB',
                value: 'GB',
                count: 127
            }],
            search: ""
        };
        return values;
    },
    computed: {
    },
    methods: {
        triggerSearch: function() {

        },
        buildAssets: function() {
            let url = '/asset-manager/build';

            AjaxUtils.ajax_get({
                url: url,
                success: function (data) {

                },
                fail: function (data) {

                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    show_success_flash: false,
                    flash_404_errors: false
                }
            });
        }
    },
    mounted: function(){

    },
    template: `
        <div class="asset-dashboard-wrapper">
            <apck-titlebar title="Asset Dashboard">
                <template v-slot:actions>
                    <apck-button
                        icon="fa-bars"
                        title="Switch to list view"
                        class="btn-primary"
                    />

                    <apck-button
                        :handler="buildAssets"
                        icon="fa-cloud-upload"
                        title="Rebuild the database"
                        class="btn-secondary"
                    />
                </template>
            </apck-titlebar>

            <div class="asset-dashboard">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col col-xs-12">
                            <apck-vuln-counter />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-xs-8">
                            <apck-map-panel title="Location" icon="fa-map-o" src="/asset-manager/countries/map" />
                        </div>

                        <div class="col col-xs-4">
                            <apck-query-panel class="map-counter-panel" :views="['list']" src="/asset-manager/countries/counter" query="country" title="Countries" icon="fa-map" />
                        </div>
                    </div>

                    
                    <div class="row">
                        <div class="col col-xs-4">
                            <apck-query-panel src="/asset-manager/os/counter" query="cpe" title="Operating Systems" icon="fa-microchip" />
                        </div>
                        <div class="col col-xs-4">
                            <apck-query-panel src="/asset-manager/software/counter" :colors="['#27ae60']" query="cpe" view="treemap" title="Software" icon="fa-briefcase" />
                        </div>

                        <div class="col col-xs-4">
                            <apck-query-panel src="/asset-manager/web_tech/counter" query="cpe" title="Web Technologies" view="treemap" icon="fa-globe" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-xs-4">
                            <apck-query-panel src="/asset-manager/ports/counter" query="port" title="Ports" icon="fa-sitemap" />
                        </div>
                        <div class="col col-xs-4">
                            <apck-query-panel src="/asset-manager/http/counter" :colors="['#f39c12']" query="banner" title="HTTP Protocols" view="treemap" icon="fa-tag" />
                        </div>

                        <div class="col col-xs-4">
                            <apck-query-panel src="/asset-manager/ssl/counter" :colors="['#c0392b']" query="ssl" title="SSL / TLS Versions" icon="fa-certificate" />
                        </div>   
                    </div>

                </div>
            </div>

        </div>
    `
}
